<template>
  <div class="d-flex flex-column flex-grow-1 rounded mr-md-3">
    <BaseToolBar title="Satisfaction client" subtitle="Liste des satisfactions enregistrées">
      <button
        class="btn btn-primary"
        v-tooltip="'Ajouter un satisfaction'"
        @click="createSatisfaction(id)"
      >Ajouter</button>
    </BaseToolBar>
    <div class="d-flex flex-column flex-md-row w-100">
      <div class="w-100" v-if="satisfactions">
        <div v-for="satisfaction in satisfactions" :key="satisfaction.id" class="w-100">
          <SatisfactionItem :affaires="affaires" :satisfaction="satisfaction" :lists="lists"></SatisfactionItem>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapFields } from "vuex-map-fields";
import { mapMultiRowFields } from "vuex-map-fields";
import { mapActions } from "vuex";
import BaseToolBar from "@/components/bases/ToolBar.vue";
import SatisfactionItem from "@/components/clients/SatisfactionItem.vue";
export default {
  components: { BaseToolBar, SatisfactionItem },
  data() {
    return {
      lists: {},
      feedback: {}
    };
  },
  props: {},
  computed: {
    ...mapFields("clients", ["client.id"]),
    ...mapMultiRowFields("clients", ["satisfactions"]),
    ...mapMultiRowFields("affaires", ["affaires"])
  },
  methods: {
    ...mapActions({
      _createSatisfaction: "clients/createSatisfaction",
      getAffaires: "affaires/getAffaires"
    }),
    createSatisfaction: function(d) {
      this.feedback = {};
      this._createSatisfaction(d).catch(error => this.errHandler(error));
    },
    errHandler: function(error) {
      if (error.response.status === 422) {
        this.feedback = error.response.data.error;
        return;
      }
    }
  },
  mounted() {
    this.getAffaires();
  }
};
</script>
